export const SIDEBAR_FACTS = [
  {
    icon: 'fa-hand-holding-heart',
    title: 'Trámite gratuito',
    description:
      'La presentación y gestión de una PQRSF no genera ningún costo para el usuario.',
  },
  {
    icon: 'fa-receipt',
    title: 'Radicación identificable',
    description:
      'Las solicitudes recibidas correctamente podrán generar un número de radicado para facilitar su seguimiento.',
  },
  {
    icon: 'fa-clock',
    title: 'Atención oportuna',
    description:
      'Cada solicitud será gestionada de acuerdo con su naturaleza y los términos establecidos por la normatividad aplicable.',
  },
  {
    icon: 'fa-user-shield',
    title: 'Información protegida',
    description:
      'Los datos suministrados serán utilizados para gestionar el trámite y cumplir las obligaciones institucionales correspondientes.',
  },
];
